import { render, staticRenderFns } from "./bankruptcyManagerInfo.vue?vue&type=template&id=3bb2eca1&scoped=true&"
import script from "./bankruptcyManagerInfo.vue?vue&type=script&lang=js&"
export * from "./bankruptcyManagerInfo.vue?vue&type=script&lang=js&"
import style0 from "./bankruptcyManagerInfo.vue?vue&type=style&index=0&id=3bb2eca1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb2eca1",
  null
  
)

export default component.exports